export const PRODUCTS_SWITCHER_LOGO =
  "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/Yotam_Ron/switcher-icon-hp.png";

export const PRODUCTS_SWITCHER_LOGO_DARK =
  "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Homepage%20-%202024/Switcher.png";
